import { TrackingDirective } from './tracking.directive';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@NgModule({
    imports: [ CommonModule ],
    declarations: [ TrackingDirective ],
    exports: [ TrackingDirective ],
})
export class TrackingDirectiveModule {}
